import React, {useEffect, useState} from 'react'
import ShowDesignVariantDetail from "../common/show-design-variant-detail";
import ShowParentProductColorList from "../common/show-parent-product-color-list";
import ShowImage from "../../../image/show-image";
import {getSingleDesignVariant, updateSingleDesignVariant} from "../../services/design-variant-data-service";
import _ from "lodash";
import {
    extractColorsFromDesignVariant,
} from "../../utils/design-variant-util";
import ShowTags from "../common/show-tags";
import PreviewDesignVariantImage from "./preview-design-variant-image";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import {DESIGN_KEY_PREFIX} from "../../constants/design.constant";
import {saveAs} from "file-saver";
import UpdateDesignVariantStatus from "../common/update-design-variant-status";
import {updateSingleDesign} from "../../services/design-data-service";
import ApplyParentProductColorList from "../common/apply-parent-product-color-list";
import {processDesignVariantStatistics} from "../../utils/design-util";
import {searchImages} from "../../../common/services/image-data-service";
import {appConfig} from "../../../firebase/client-app";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {prepareDesignTags} from "../../utils/design-tag-util";

const DesignDetailTable = ({
                               designDetail,
                               designTagList,
                               parentProduct,
                               isTagTextList = false,
                           }) => {

    return (
        <>
            <div className="mb-4">
                <table className="w-full">
                    <tbody className="">

                    <tr className="border border-gray-400">
                        <td className="w-48 p-2 border-r border-gray-400">
                            <div className="field-label-bold font-bold">Design Name</div>
                        </td>
                        <td className="w-3/5 p-2 border-r border-gray-400">
                            <div className="text-lg ml-2 flex text-purple-700 font-semibold">
                                {designDetail?.name}
                            </div>
                        </td>
                        <td className="w-48 p-2">
                            <div className="flex justify-around">
                                <CopyDataToClipboard value={designDetail?.name}/>
                            </div>
                        </td>
                    </tr>

                    <tr className="border border-gray-400">
                        <td className="w-48 p-2 border-r border-gray-400">
                            <div className="field-label-bold font-bold">Quote</div>
                        </td>
                        <td className="w-3/5 p-2 border-r border-gray-400">
                            <div className="text-lg ml-2 flex text-purple-700">
                                {designDetail?.quoteName}
                            </div>
                        </td>
                        <td className="w-48 p-2">
                            <div className="flex justify-around">
                                <CopyDataToClipboard value={designDetail?.quoteName}/>
                            </div>
                        </td>
                    </tr>

                    <tr className="border border-gray-400">
                        <td className="w-48 p-2 border-r border-gray-400">
                            <div className="field-label-bold font-bold">Theme</div>
                        </td>
                        <td className="w-3/5 p-2 border-r border-gray-400">
                            <div className="text-lg ml-2 flex text-purple-700">
                                {designDetail?.themeName}
                            </div>
                        </td>
                        <td className="w-48 p-2">
                            <div className="flex justify-around">
                                <CopyDataToClipboard value={designDetail?.themeName}/>
                            </div>
                        </td>
                    </tr>

                    <tr className="border border-gray-400">
                        <td className="w-48 p-2 border-r border-gray-400">
                            <div className="field-label-bold font-bold">Parent Product</div>
                        </td>
                        <td className="w-3/5 p-2 border-r border-gray-400">
                            <div className="text-lg ml-2 flex text-purple-700">
                                {designDetail?.parent}
                            </div>
                        </td>
                        <td className="w-48 p-2">
                            <div className="flex justify-around">
                                <CopyDataToClipboard value={designDetail?.parent}/>
                            </div>
                        </td>
                    </tr>

                    <tr className="border border-gray-400">
                        <td className="w-48 p-2 border-r border-gray-400">
                            <div className="field-label-bold font-bold">Profit Percentage</div>
                        </td>
                        <td className="w-3/5 p-2 border-r border-gray-400">
                            <div className="text-lg ml-2 flex text-purple-700">
                                {parentProduct?.profitPercentage} %
                            </div>
                        </td>
                        <td className="w-48 p-2">
                            <div className="flex justify-around">
                                <CopyDataToClipboard value={parentProduct?.profitPercentage}/>
                            </div>
                        </td>
                    </tr>

                    <tr className="border border-gray-400">
                        <td className="w-48 p-2 border-r border-gray-400">
                            <div className="field-label-bold font-bold">Design Tags</div>
                        </td>
                        <td className="w-3/5 p-2 border-r border-gray-400">
                            {/* <ShowTags tagDetailList={_.shuffle(designTagList)}/> */}

                            {isTagTextList &&
                                <ShowTags tagDetailList={_.orderBy(designTagList)}/>
                            }

                            {!isTagTextList &&
                                <ShowTags tagDetailList={_.orderBy(designTagList, ['startText'])}/>
                            }
                        </td>
                        <td className="w-48 p-2">
                            <div className="flex justify-around">
                                {isTagTextList &&
                                    <CopyDataToClipboard
                                        value={_.join(_.compact(_.uniq(designTagList)), ', ')}/>
                                }

                                {!isTagTextList &&
                                    <CopyDataToClipboard
                                        value={_.join(_.compact(_.uniq(_.map(designTagList, 'startText'))), ', ')}/>
                                }
                            </div>
                        </td>
                    </tr>

                    </tbody>
                </table>
            </div>
        </>
    )
}

export default DesignDetailTable
